export const hourlyConversionFactor = 2080;
export const normalizePayRange = (pay, hourlyPay, rangeMin, rangeMax, hourlyRange) => {
    let normalizedMin = rangeMin;
    let normalizedMax = rangeMax;
    let conversionFactor = 1;
    if (hourlyPay && !hourlyRange) {
        conversionFactor = hourlyConversionFactor;
    }
    else if (hourlyRange && !hourlyPay) {
        conversionFactor = 1 / hourlyConversionFactor;
    }
    if (normalizedMin) {
        normalizedMin /= conversionFactor;
    }
    if (normalizedMax) {
        normalizedMax /= conversionFactor;
    }
    return {
        rangeMin: normalizedMin,
        rangeMax: normalizedMax
    };
};
